import {AppActionState, AppAction, IAppState} from './interfaces/IAppState';

export class ActionHandler {
  static handle(state: IAppState, actionType: AppAction, callbackSuccess: (state: IAppState) => void, callbackError: (state: IAppState) => void) {
    if (state.actionType === actionType) {
      if (state.state === AppActionState.SUCCESS ) {
        callbackSuccess(state);
      } else if (state.state === AppActionState.ERROR ) {
        callbackError(state);
      }
    }
  }
  static handleState(state: IAppState, actionType: AppAction, actionState: AppActionState, callback: (state: IAppState) => void) {
    if (state.actionType === actionType
      &&   state.state === actionState ) {
      callback(state);
    }
  }
  static handleAction(state: IAppState, actionType: AppAction, callback: (state: IAppState) => void) {
    if (state.actionType === actionType ) {
      callback(state);
    }
  }

  static handleError(state: IAppState, actionType: AppAction, callback: (state: IAppState) => void) {
    ActionHandler.handleState(state, actionType, AppActionState.ERROR, callback);
  }

  static handleSuccess(state: IAppState, actionType: AppAction, callback: (state: IAppState) => void) {
    ActionHandler.handleState(state, actionType, AppActionState.SUCCESS, callback);
  }
  static handleInitial(state: IAppState, actionType: AppAction, callback: (state: IAppState) => void) {
    ActionHandler.handleState(state, actionType, AppActionState.INITIAL, callback);
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/store/action.handler.ts